import { useCurationTokenPermissions } from "@/features/token-permissions/composables/useCurationTokenPermissions";
import { useRouteQuery } from "@vueuse/router";
import { defineStore } from "pinia";
import { ViewType } from "../components/ViewSelect.vue";
import { userShouldDefaultToCommercialView, VIEW_TYPE_ALL, VIEW_TYPE_COMMERCIAL } from "../lib/viewTypeUtils";
import { getDistributionState } from "@/features/experience-shared/utils/get-experience-state";
import { useCurrentDistributionContentQuery } from "@/features/experience-shared/composables/useCurrentDistributionContentQuery";
import { useCurationQueries } from "@/features/experience-curation/composables/useCurationQueries";
import { useCurationMutations } from "@/features/experience-curation/composables/useCurationMutations";

export const useCurationExperienceStore = defineStore("useCurationExperienceStore", () => {
  const { canEditCuration } = useCurationTokenPermissions();
  const isReadonly = !canEditCuration();
  const showRawFields = ref(true);
  const selectedView = useRouteQuery<ViewType>("view", VIEW_TYPE_ALL);
  const isCommercialView = computed(() => selectedView.value === VIEW_TYPE_COMMERCIAL);

  const queries = useCurationQueries();
  const mutations = useCurationMutations();

  const isLoading = computed(() => queries.some((q) => "isLoading" in q && q.isLoading.value));
  const isSavingDraft = computed(() => mutations.some((m) => m.isPending.value));

  const distributionContentQuery = useCurrentDistributionContentQuery();
  const distributionState = computed(() => getDistributionState(distributionContentQuery.data.value));
  const isOpinoiaExperience = computed(() => distributionContentQuery.data.value?.experience_source === "INTERNAL");

  setCommercialViewIfNecessary();

  function setCommercialViewIfNecessary() {
    if (userShouldDefaultToCommercialView()) {
      selectedView.value = VIEW_TYPE_COMMERCIAL;
    }
  }

  return {
    isReadonly,
    isLoading,
    distributionState,
    showRawFields,
    selectedView,
    isCommercialView,
    isOpinoiaExperience,
    isSavingDraft,
  };
});
